import React__default, { createContext, forwardRef, useContext } from 'react';
import { HappyWebSystemError } from '../components/base/SystemComponent.js';
import { IconSpriteSheet } from '../components/icon/Icon.js';
import { useHasI18NextContext, TranslateProvider } from '../lib/translate.js';

/**
 * Creates a Design System link component that is leveraged for all links.
 * Allows use of any client-side routing solution with the Design System Link.
 */ const makeLinkComponent = (render)=>({
        __forwardRef__: forwardRef(render)
    });
const DefaultLinkComponent = makeLinkComponent((props, ref)=>React__default.createElement("a", {
        ...props,
        ref: ref,
        href: props.to,
        target: props.externalLink ? "_blank" : undefined,
        "data-test-id": props["data-test-id"] ?? `Link-${props.testId}`,
        rel: "noreferrer"
    }, props.children));
const LinkComponentContext = createContext(DefaultLinkComponent);
const useLinkComponent = ()=>{
    const linkComponent = useContext(LinkComponentContext);
    if (linkComponent === undefined || linkComponent.__forwardRef__ === undefined) {
        throw new HappyWebSystemError("useLinkComponent", "Undefined link component - this hook must be used from within a Happy Design Provider with a link component created via the make link component helper.");
    }
    return linkComponent.__forwardRef__;
};
/**
 * Sets up the required providers for the Happy Design react set of components.
 */ const HappyDesignProvider = (props)=>{
    const hasI18NextProvider = useHasI18NextContext();
    if (!hasI18NextProvider) {
        throw new HappyWebSystemError("HappyDesignProvider", "No i18next instance has been defined, add the i18next provider from react-i18next as a wrapping context to Happy Design Provider.");
    }
    return React__default.createElement(TranslateProvider, null, React__default.createElement(IconSpriteSheet, null), React__default.createElement(LinkComponentContext.Provider, {
        value: props.linkComponent
    }, props.children));
};

export { HappyDesignProvider, makeLinkComponent, useLinkComponent };
